import {API} from '../API';

// Las respuestas del backend vienen como Resource `{data: ...}`; se tolera
// también el cuerpo sin envolver para no depender de la forma exacta.
function unwrap(response) {
    return response && response.data !== undefined ? response.data : response;
}

const killSwitches = {
    list: async () => {
        const {data: response} = await API.get('/settings/kill-switches');

        return unwrap(response) || [];
    },
    update: async (key, enabled, reason) => {
        const {
            data: response,
        } = await API.put(
            `/settings/kill-switches/${encodeURIComponent(key)}`,
            {enabled, reason},
        );

        return unwrap(response);
    },
    inFlight: async () => {
        const {data: response} = await API.get(
            '/settings/kill-switches/payments/in-flight',
        );

        return unwrap(response).inFlight;
    },
};

export default killSwitches;
